import { NetFront } from "@/constants/netEvent";
import { reqPost } from "@/service/clientRequest";
import {
  GetHotCoolGameListRsp,
  GetMakerListReq,
  GetMakerListRsp,
  PersonalizedBoardsRep,
  PersonalizedGamesReq,
  PersonalizedGamesRsp,
} from "@/types/swagger/front";

export const postGetFrontMakers = (params: GetMakerListReq) => {
  return reqPost<GetMakerListReq, GetMakerListRsp>(
    params,
    NetFront.mod,
    NetFront.GetFrontMakers,
    false,
    undefined,
    undefined,
    {
      ttl: 1000 * 60 * 60,
      forceRefresh: false,
    },
  );
};

// 需要登入的猜你喜欢
export const postPersonalizedGames = (params: PersonalizedGamesReq) => {
  return reqPost<PersonalizedGamesReq, PersonalizedGamesRsp>(
    params,
    NetFront.mod,
    NetFront.PersonalizedGames,
    true, // 需要登录
    undefined,
    undefined,
    {
      ttl: 1000 * 60 * 60,
      forceRefresh: false,
    },
  );
};

// 不需登入的猜你喜欢
export const postDefaultPersonalizedGames = (params: PersonalizedGamesReq) => {
  return reqPost<PersonalizedGamesReq, PersonalizedGamesRsp>(
    params,
    NetFront.mod,
    NetFront.GetPersonalizedGames,
    false,
    undefined,
    undefined,
    {
      ttl: 1000 * 60 * 60,
      forceRefresh: false,
    },
  );
};

// 猜你喜欢聚合榜单未登录
export const getNoLoginPersonalizedBoards = (params: PersonalizedGamesReq) => {
  return reqPost<PersonalizedGamesReq, PersonalizedBoardsRep>(
    params,
    NetFront.mod,
    NetFront.GetPersonalizedBoards,
    false, // 不需要登录
    undefined,
    undefined,
    {
      ttl: 1000 * 60 * 60,
      forceRefresh: false,
    },
  );
};

// 猜你喜欢聚合榜单登陆
export const getLoginPersonalizedBoards = (params: PersonalizedGamesReq) => {
  return reqPost<PersonalizedGamesReq, PersonalizedBoardsRep>(
    params,
    NetFront.mod,
    NetFront.PersonalizedBoards,
    true, // 需要登录
    undefined,
    undefined,
    {
      ttl: 1000 * 60 * 60,
      forceRefresh: false,
    },
  );
};

// 冷热游戏
export const getHotColdGame = () => {
  return reqPost<{}, GetHotCoolGameListRsp>(
    {},
    NetFront.mod,
    NetFront.GetHotCoolGameList,
    false,
  );
};
